import React from "react";
import logolight from "assets/svg/logo-light.svg";
import logoDark from "assets/svg/logo-dark.svg";

interface AppProps {
	mode?: "light" | "dark";
}

const AppLogo: React.FC<AppProps> = ({ mode = "light" }) => {
	return <img src={mode === "dark" ? logoDark : logolight} alt="logo" />;
};

export default AppLogo;
